<template>
    <div>
      <div :style="'z-index: 0;position: relative;height:170px;color#fff;padding:15px;background-color:' + ($isTargetShop ?'#FFA300': $bgColor) ">
        <v-row>
          <div @click="$router.go(-1)" :style="'color:' + $CUSTOMMainTextColor + ';font-size: 20px;padding:15px;'"> <v-icon>mdi-chevron-left</v-icon>{{ $t("message.MyPoint") }}</div>
          <div style="align-items: center;display: flex;">
            <img
              v-if="profile && profile.pictureUrl"
              style="border-color: white; height: 20px;"
              alt="Avatar"
              :src="HEXToVBColorLMG($bgColor) ? $images.pointWhite : $images.pointHistoryWhite"
            />
          </div>
        </v-row>
          <v-row justify="center" class="mt-3 pt-2">
            <v-col cols="4" align="center" class="pa-2" style="font-size:15px;background-color:#ffff;position:relative;">
              <div style="position:absolute;right:0;top:10px;bottom:10px;width:2px;background-color:#F2F0F0;"></div>
              {{ isTargetShop ? $t('message.MyReward') : $t("message.MyPoint") }}
            <v-col align="center" class="pa-0" :style="';font-size:20px !important;color:' + $CUSTOMMainTextColor" >{{ formatNumber(newData.currentPoint) }}</v-col>
          </v-col>
           <v-col cols="4" align="center" class="pa-2" style="font-size:15px;background-color:#ffff;">
              {{ isTargetShop ? $t('message.expireReward') : $t("message.PointsUsed") }}
            <v-col align="center" :style="';font-size:20px !important;color:' + $CUSTOMMainTextColor" class="pa-0">{{ isTargetShop ? formatNumber(newData.expirePoint) : formatNumber(newData.redeemPoint) }}</v-col>
          </v-col>
          </v-row>
      </div>
      <!-- ------------------------------------------------- -->
      <!-- <div class="choice" :style="'margin-left:15px;border: 1px solid '+ levelById.color +';' " @click="$router.push('/C/ExchangeToDiscount').catch(()=>{})">
            <div style="display: flex; justify-content: center; align-items: center;padding: 10px;">
              <img :src="$images.myReward" alt="" width="40" style="margin-right: auto;">
              <h3 style="margin-left: auto; font-size: 1.25rem;">{{ $t("message.ExchangeToDiscount") }}</h3>
            </div>
        </div> -->
      <!-- ------------------------------------------------- -->
      <div class="choice" :style="'margin-left:15px;border: 1px solid '+ (isTargetShop ? '#000' :levelById.color) +';' " @click="$router.push('/C/Transaction').catch(()=>{})">
            <!-- cal -->
            <div style="display: flex; justify-content: center; align-items: center;padding: 10px;">
              <div style="background-color: #FFA300; padding: 8px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-right: auto;">
                <img :src="$images.pointHistoryWhite" alt="" width="20">
              </div>
              <h3 v-if="!$isTargetShop()" style="margin-left: auto; font-size: 1.25rem;">{{ $t("message.pointHistory") }}</h3>
              <div v-else style="margin-left: auto; font-size: 18px;">{{ $t("message.pointHistory") }}</div>
            </div>
        </div>
      <!-- ------------------------------------------------- -->
    </div>
  </template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MyPoints',
  data () {
    return {
      dialogConfromLin: false,
      member: null,
      profile: null,
      use: null,
      items: null,
      dialog: false,
      today: new Date(),
      tab: null,
      shopId: null,
      selected: '',
      levelById: null,
      expirePoint: 0
    }
  },
  async mounted () {
    window.scrollTo(0, 0)
    this.member = await this.GET_MEMBERINFO()
    this.profile = await this.getLiffProfile()
    this.shopId = await this.GET_SHOPID()
    await this.getLevelById()
    if (this.isTargetShop && this.profile && this.shopId) {
      await this.fetchExpirePoint()
    }
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),
    async fetchExpirePoint () {
      try {
        const lineUserId = (this.profile && this.profile.userId) || (this.member && this.member.liffUserId)
        const shopId = this.shopId
        if (!lineUserId || !shopId) return
        const url = `/get-history-expire-coin-by-useId/get?lineUserId=${lineUserId}&shopId=${shopId}`
        const response = await this.callBeTaskAPI('get', url)
        if (response && Array.isArray(response)) {
          this.expirePoint = response.reduce((sum, item) => sum + (item.balancePoint || 0), 0)
        } else {
          this.expirePoint = 0
        }
      } catch (e) {
        this.expirePoint = 0
      }
    },
    async getLevelById () {
      if (!this.member || !this.member.levelId) {
        this.levelById = null
        return
      }
      const result = await this.callBeTaskAPI(
        'get',
        `/level/getID?RECORD_STATUS=N&levelId=${this.member.levelId}`
      )
      if (result) {
        this.levelById = result
      } else {
        this.levelById = null
      }
    },
    HEXTHEMELMG (hex) {
      if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(hex)) {
        return true
      }

      let rr = parseInt(hex.substring(1, 3), 16)
      let gg = parseInt(hex.substring(3, 5), 16)
      let bb = parseInt(hex.substring(5, 7), 16)

      let brightness = (rr * 0.299) + (gg * 0.587) + (bb * 0.114)

      return brightness > 180
    },
    HEXToVBColorLMG (a) {
      let rr = parseInt(a.substr(1, 2), 16)
      let gg = parseInt(a.substr(3, 2), 16)
      let bb = parseInt(a.substr(5, 2), 16)

      let brightness = (rr * 0.299) + (gg * 0.587) + (bb * 0.114)

      return brightness > 180
    }
  },
  computed: {
    newData () {
      const memberInfo = this.GET_MEMBERINFO()
      if (this.isTargetShop) {
        return {
          ...memberInfo,
          expirePoint: this.expirePoint
        }
      }
      return memberInfo
    },
    isTargetShop () {
      return this.$isTargetShop()
    }
  }
}
</script>
<style scoped>
.choice{
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0);
  width: calc(100% - 30px);
  height: 60px;
  border-radius: 8px;
  margin: 10px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeCUSTOM/MyPoints.vue